// Name matching shared by the sky-data generator (Node) and the FOV tool's
// target search (browser), so designations and nicknames are folded the same
// way on both sides.

// Catalogue designations get typed every which way: "IC434", "IC 434",
// "ic-434", OpenNGC's zero-padded "IC0434", "Messier 31", "Sharpless 129",
// "Barnard 33". Fold them all to one compact form ("ic434", "m31", "sh2129",
// "b33") so they compare equal.
const normalizeDesignation = (s) => String(s || '')
    .toLowerCase()
    .replace(/\bmessier\s*/g, 'm')
    .replace(/\bcaldwell\s*/g, 'c')
    .replace(/\bbarnard\s*/g, 'b')
    .replace(/\bsharpless\s*(2\s*[-\s]\s*)?/g, 'sh2 ')
    .replace(/\bsh\s*2\s*[-\s]\s*/g, 'sh2 ')
    .replace(/[^a-z0-9]/g, '')
    .replace(/^sh20+(?=\d)/, 'sh2')
    .replace(/([a-z])0+(?=\d)/g, '$1');

// Nicknames compare with case, punctuation and spacing ignored, so
// "elephants trunk", "Thor's" and "pac man" still find their targets.
const normalizeName = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// OpenNGC keys ("IC0434", "NGC0281") as people write them ("IC 434").
const displayDesignation = (key) => key.replace(/^(NGC|IC)0*(\d+)$/, '$1 $2');

module.exports = { normalizeDesignation, normalizeName, displayDesignation };
